// Fase 7 — antes de esta fase el router usaba hash routing (#/producto/x).
// Se reemplaza por History API con URLs limpias: es un requisito de SEO
// (sección 22.1 del funcional) — un buscador no indexa fragmentos de hash
// como rutas distintas, y las URLs limpias son las que se publican en el
// sitemap (ver seo-estatico.js).

/** @type {(ruta: string) => void} */
let suscriptor = () => {};

export function obtenerRutaActual() {
  return `${window.location.pathname}${window.location.search}`;
}

/**
 * Navega a una ruta interna actualizando la URL sin recargar la página.
 * @param {string} ruta
 */
export function navegarA(ruta) {
  if (obtenerRutaActual() === ruta) return;
  window.history.pushState(null, '', ruta);
  suscriptor(ruta);
}

/**
 * Determina si un click sobre un <a> debe ser interceptado por el router
 * (navegación interna sin recarga) o dejado pasar (enlace externo, WhatsApp,
 * mailto, target="_blank", descarga, o el usuario usó un modificador para
 * abrir en pestaña/ventana nueva).
 * @param {MouseEvent} evento
 * @param {HTMLAnchorElement} enlace
 */
function esNavegacionInterna(evento, enlace) {
  if (evento.defaultPrevented) return false;
  if (evento.button !== 0) return false;
  if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return false;
  if (enlace.target && enlace.target !== '_self') return false;
  if (enlace.hasAttribute('download')) return false;
  if (enlace.origin !== window.location.origin) return false;
  return true;
}

function interceptarEnlaces() {
  document.addEventListener('click', (evento) => {
    const objetivo = /** @type {HTMLElement} */ (evento.target);
    const enlace = /** @type {HTMLAnchorElement | null} */ (objetivo.closest('a'));
    if (!enlace || !esNavegacionInterna(evento, enlace)) return;

    evento.preventDefault();
    navegarA(`${enlace.pathname}${enlace.search}`);
  });
}

/** @param {(ruta: string) => void} callback */
export function iniciarRouter(callback) {
  suscriptor = callback;
  interceptarEnlaces();
  window.addEventListener('popstate', () => suscriptor(obtenerRutaActual()));
  suscriptor(obtenerRutaActual());
}

/**
 * @param {string} ruta
 * @returns {{ pathname: string, params: URLSearchParams }}
 */
export function partirRuta(ruta) {
  const [pathname, query = ''] = ruta.split('?');
  return { pathname, params: new URLSearchParams(query) };
}
